import type {
  BoardRecurringTasksBoardState,
  BoardRecurringTasksSliceState,
} from './boardRecurringTasks.types'

export const EMPTY_BOARD_RECURRING_TASKS_BOARD_STATE: BoardRecurringTasksBoardState =
  {
    items: [],
    loading: false,
    saving: false,
    deletingId: null,
    error: null,
  }

export const createEmptyBoardRecurringTasksBoardState =
  (): BoardRecurringTasksBoardState => ({
    items: [],
    loading: false,
    saving: false,
    deletingId: null,
    error: null,
  })

export const createInitialBoardRecurringTasksState =
  (): BoardRecurringTasksSliceState => ({
    byBoardId: {},
  })
